export default function AboutMe() {
    return <section id="AboutMe" className="about--section">
        <div className="about--section--img">
            <img src="./img/aps-about-me.jpg" alt="About Me" />
        </div>
        <div className="hero--section--content--box about--section--box">
            <div className="hero--section--content">
                <h1 className="skills-section--heading">
                    About Me
                </h1>
                <p className="hero--section-description">
                    I'm Aparna Anand, a Computer Science graduate from Michigan State University's College of Engineering with a minor in Business. I currently work as a Site Reliability Engineer at C3 AI. I focus on building reliable, scalable systems and improving developer operations workflows across complex environments.
                </p>
                <p className="hero--section-description">
                    I manage lifecycle operations for distributed Kubernetes clusters and deliver Terraform-based observability infrastructure across AWS, Azure, and GCP, improving dashboard consistency and alert quality. I also built an agentic AI workflow that indexed Jira incident data in a vector database to accelerate root-cause analysis for SRE teams.
                </p>
            </div>
        </div>
    </section>
}